import { Breadcrumbs } from "components/breadcrumbs";
import { useCreate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { IFipixEventForm } from "interfaces";
import { useNavigate } from "react-router-dom";
import { FipixEventForm } from "./components";

export const CreateFipixEvent: React.FC = () => {

  const { mutate, isLoading: isSubmitingSubCategoryForm } = useCreate();
  const navigate = useNavigate();

  const onSubmit = (values: IFipixEventForm) => {
    const submitValues = { ...values };
    mutate(
      {
        resource: "fipix/events",
        meta: {
          ignoreResourceWrapper: true,
        },
        values: {
          ...submitValues,
        },
      },
      {
        onSuccess: () => {
          toast.success("Create successfully");
          navigate(`/fipix/events`);
        },
      }
    );
  };

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create Fipix event" />
      <FipixEventForm onSubmit={onSubmit} />
      {isSubmitingSubCategoryForm ? <FullScreenLoading /> : <></>}
    </div>
  );
};
